export default __webpack_public_path__ + "static/media/neuheiten-2024.e2528dee.webp";